import React from 'react';

class QRCodeIcon extends React.Component {

    static defaultProps = {
        color: 'black',
        width: 24,
        height: 24,
    };

    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="mdi-qrcode-plus"
                 width={this.props.width} height={this.props.height} viewBox="0 0 24 24">
                <path
                    fill={this.props.color}
                    d="M5 5H7V7H5V5M1 1H11V11H1V1M3 3V9H9V3H3M5 17H7V19H5V17M1 13H11V23H1V13M3 15V21H9V15H3M13 13H17V15H19V13H23V15H19V17H23V23H19V21H15V23H13V21H15V19H13V13M21 21V19H19V21H21M19 17H17V15H15V19H19V17M17 2V5H14V7H17V10H19V7H22V5H19V2Z"
                />
            </svg>
        );
    }
}

export default QRCodeIcon;



// WEBPACK FOOTER //
// src/components/icon/QRCodeIcon.js